<template>
  <div>
    <div class="wrapper">
    <!-- <div :class="'wrapper ' + (show ? '' : 'sidebar_minimize') "> -->
      <!---------------------------------------------------------- top -->
      <div class="main-header">
        <!-- Logo Header -->
        <div class="logo-header" data-background-color="blue">
          <a href="javascript:void(0)" @click="refresh_active('/welcome')" class="logo">
            <img :src="custom.image || 'img/F1-uwss.png'" alt="navbar brand" class="navbar-brand" width="150">
          </a>

          <button class="navbar-toggler sidenav-toggler ml-auto" type="button" data-toggle="collapse" data-target="collapse" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon">
                  <i class="icon-menu icon_menu_01"></i>
              </span>
          </button>
          <button class="topbar-toggler more">
              <i class="icon-options-vertical icon_menu_01"></i>
          </button>
          <div class="nav-toggle">
              <button class="btn btn-toggle toggle-sidebar toggled">
                  <i class="icon-menu icon_menu_01"></i>
              </button>
          </div>
        </div>
        <!-- End Logo Header -->

        <!-- Navbar Header -->
        <nav class="navbar navbar-header navbar-expand-lg" data-background-color="blue2">
          <div class="container-fluid">
            <div class="collapse" id="search-nav">
              <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
                <li class="nav-item" data-name="/webcastle/dashboard"
                  v-if="auth && auth.license && auth.license.WEBCastle && auth.license.WEBCastle.use == true && allow_solution_dashboard"
                >
                  <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/webcastle/dashboard')">
                    <div class="p-1"><i class="fas fa-paste top_icon"></i></div>
                    <div class="nav_link_tit">WEBCastle</div>
                    <div class="nav_link_sub font_10">(웹방화벽)</div>
                  </a>
                </li>
                <li class="nav-item" data-name="/wsfinder/dashboard"
                  v-if="auth && auth.license && auth.license.WSFinder && auth.license.WSFinder.use == true && allow_solution_dashboard"
                >
                  <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/wsfinder/dashboard')">
                    <div class="p-1"><i class="fas fa-table top_icon"></i></div>
                    <div class="nav_link_tit">WSFinder</div>
                    <div class="nav_link_sub font_10">(웹쉘 탐지 시스템)</div>
                  </a>
                </li>
                <li class="nav-item" data-name="/wmds/dashboard"
                  v-if="auth && auth.license && auth.license.WMDS && auth.license.WMDS.use == true && allow_solution_dashboard"
                >
                  <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/wmds/dashboard')">
                    <div class="p-1"><i class="fas fa-list-alt top_icon"></i></div>
                    <div class="nav_link_tit">WMDS</div>
                    <div class="nav_link_sub font_10">(웹 악성코드 유포지 탐지 시스템)</div>
                  </a>
                </li>
                <li class="nav-item" data-name="/integrity/dashboard"
                  v-if="auth && auth.license && auth.license.WFDetect && auth.license.WFDetect.use == true && allow_solution_dashboard"
                >
                  <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/integrity/dashboard')">
                    <div class="p-1"><i class="fas fa-th-list top_icon"></i></div>
                    <div class="nav_link_tit">WFDetector</div>
                    <div class="nav_link_sub font_10">(웹 위변조 탐지 시스템)</div>
                  </a>
                </li>
                <li class="nav-item" data-name="">
                  <a class="nav-link" href="javascript:void(0)" @click="manual()">
                    <div class="nav_link_tit">메뉴얼</div>
                  </a>
                </li>
                <!-- <li class="nav-item d-inline-flex">
                  <Language />
                </li> -->
              </ul>
            </div>
            <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
              <li class="nav-item dropdown hidden-caret">
                <Language />
              </li>
              <li class="nav-item hidden-caret" data-name="/profile">
                <a class="nav-link-toggle" href="javascript:void(0)" @click="refresh_active('/profile')">
                  <i class="fas fa-user-alt mr-1 user_i"></i>
                  <span class="user" style="font-size:13px !important;">
                    {{auth.profile.username}}
                  </span>
                </a>
              </li>
              <li class="nav-item hidden-caret" data-name="/welcome">
                <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/welcome')">
                  <i class="fas fa-bell nav_link_I"></i>
                  <span class="notification" v-if="auth.UWSS_status == 2" style="background-color: red;">위험</span>
                  <span class="notification" v-else-if="auth.UWSS_status == 1" style="background-color: #ffc108;">주의</span>
                  <span class="notification" v-else style="background-color: #4ebd75 ;">안전</span>
                </a>
              </li>
              <li class="nav-item hidden-caret">
                <a class="nav-link" href="javascript:void(0)" @click="toggle">
                  <i class="fas fa-history nav_link_I"></i>
                  <span class="notification" :class="{ 'bg-secondary': pause }">{{stale}}</span>
                </a>
              </li>
              <li class="nav-item hidden-caret">
                <button class="btn btn-search" @click="logout()">
                  <i class="fas fa-sign-out-alt mr-1"></i>
                  <span>로그아웃</span>
                </button>
              </li>
            </ul>
          </div>
        </nav>
        <!-- End Navbar -->
      </div>
      <!---------------------------------------------------------- top-->
      <!---------------------------------------------------------- sub-->
      <!-- Sidebar -->
      <div class="sidebar sidebar-style-2">
        <div class="sidebar-wrapper scrollbar scrollbar-inner scroll-scrolly_visible">
          <div class="sidebar-content">
            <ul class="nav nav-primary">
              <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                  <span class="pr-1">
                    <!-- <i class="icon-tag"></i> -->
                  </span>
                  관리
                </h4>
              </li>
              <li class="nav-item" data-name="/group">
                <a href="javascript:void(0)" @click="refresh_active('/group')">
                  <i class="fas fa-users"></i>
                  <p>그룹</p>
                </a>
              </li>
              <li class="nav-item" data-name="/user">
                <a href="javascript:void(0)" @click="refresh_active('/user')">
                  <i class="fas fa-user"></i>
                  <p>사용자</p>
                </a>
              </li>
              <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                  <span class="pr-1">
                    <!-- <i class="icon-tag"></i> -->
                  </span>
                  요약
                </h4>
              </li>
              <li class="nav-item" data-name="/downloads">
                <a href="javascript:void(0)" @click="refresh_active('/downloads')">
                  <i class="fas fa-download"></i>
                  <p>다운로드</p>
                </a>
              </li>
              <li class="nav-item" data-name="/welcome">
                <a href="javascript:void(0)" @click="refresh_active('/welcome')">
                  <i class="fas fa-chart-line"></i>
                  <p>상황판</p>
                </a>
              </li>
              <li class="nav-item" data-name="/report">
                <a href="javascript:void(0)" @click="refresh_active('/report')">
                  <i class="fas fa-clipboard"></i>
                  <p>보고서</p>
                </a>
              </li>
              <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff; ">
                  <span class="pr-1">
                  </span>
                  보안 설정
                </h4>
              </li>
              <li class="nav-item" data-name="/webcastle">
                <a data-toggle="collapse" href="#WEBCastle">
                  <i class="fas fa-paste"></i>
                  <p>WEBCastle</p>
                  <span class="caret"></span>
                </a>
                <div class="collapse" id="WEBCastle">
                  <ul class="nav nav-collapse">
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/webcastle/agent')">
                        <span class="sub-item">서버</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/webcastle/log')">
                        <span class="sub-item">로그</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="nav-item" data-name="/wsfinder" v-if="auth && auth.license && auth.license.WSFinder && auth.license.WSFinder.use == true">
                <a data-toggle="collapse" href="#WSFinder">
                  <i class="fas fa-table"></i>
                  <p>WSFinder</p>
                  <span class="caret"></span>
                </a>
                <div class="collapse" id="WSFinder">
                  <ul class="nav nav-collapse">
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/agent')">
                        <span class="sub-item">에이전트</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/detect')">
                        <span class="sub-item">탐지</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/result')">
                        <span class="sub-item">결과</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/hash')">
                        <span class="sub-item">예외</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/report')">
                        <span class="sub-item">분석 요청</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/pattern')">
                        <span class="sub-item">패턴</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="nav-item" data-name="/wmds" v-if="auth && auth.license && auth.license.WMDS && auth.license.WMDS.use == true">
                <a data-toggle="collapse" href="#WMDS">
                  <i class="fas fa-list-alt"></i>
                  <p>WMDS</p>
                  <span class="caret"></span>
                </a>
                <div class="collapse" id="WMDS">
                  <ul class="nav nav-collapse">
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/site')">
                        <span class="sub-item">사이트</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/pattern')">
                        <span class="sub-item">패턴</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/detect')">
                        <span class="sub-item">탐지</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/result')">
                        <span class="sub-item">결과</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/schedule')">
                        <span class="sub-item">일정</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/policy')">
                        <span class="sub-item">정책</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="nav-item" data-name="/integrity" v-if="auth && auth.license && auth.license.WFDetect && auth.license.WFDetect.use == true">
                <a data-toggle="collapse" href="#WFDetector">
                  <i class="fas fa-th-list"></i>
                  <p>WFDetector</p>
                  <span class="caret"></span>
                </a>
                <div class="collapse" id="WFDetector">
                  <ul class="nav nav-collapse">
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/integrity/main')">
                        <span class="sub-item">요약</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/integrity/wsfinder')">
                        <span class="sub-item">WSFinder</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/integrity/wmds')">
                        <span class="sub-item">WMDS</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/integrity/detect')">
                        <span class="sub-item">탐지</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                  <span class="pr-1">
                    <!-- <i class="icon-tag"></i> -->
                  </span>
                  게시판
                  <!-- 지원 -->
                </h4>
              </li>
              <!-- <li class="nav-item" data-name="/boards/qna">
                <a href="javascript:void(0)" @click="support()">
                  <i class="fas fa-question-circle"></i>
                  <p>기술 지원</p>
                </a>
              </li> -->
              <li class="nav-item" data-name="/boards/qna">
                <a href="javascript:void(0)" @click="refresh_active('/boards/qna')">
                  <i class="fas fa-question-circle"></i>
                  <p>Q &amp; A</p>
                </a>
              </li>
              <li class="nav-item" data-name="/boards/faq">
                <a href="javascript:void(0)" @click="refresh_active('/boards/faq')">
                  <i class="fas fa-filter"></i>
                  <p>FAQ</p>
                </a>
              </li>
              <li class="nav-item" data-name="/boards/notice">
                <a href="javascript:void(0)" @click="refresh_active('/boards/notice')">
                  <i class="fas fa-bell"></i>
                  <p>공지사항</p>
                </a>
              </li>
              <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                  <span class="pr-1">
                    <!-- <i class="icon-tag"></i> -->
                  </span>
                  정보
                </h4>
              </li>
              <li class="nav-item" data-name="/profile">
                <a href="javascript:void(0)" @click="refresh_active('/profile')">
                  <i class="far fa-address-card"></i>
                  <p>계정</p>
                </a>
              </li>
              <li class="nav-item" data-name="">
                <a href="javascript:void(0)" @click="logout()">
                  <i class="fas fa-sign-out-alt"></i>
                  <p>로그아웃</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!---------------------------------------------------------- sub-->
      <div class="main-panel">
        <div class="content">
          <div class="container-fluid">
            <router-view></router-view>
          </div>
        </div>
        <!---------------------------------------------------------- footer-->
        <footer class="footer">
          <div class="container-fluid text-center">
            <div v-if="!is_custom" style="margin: 0 auto !important;">
              <a href="http://www.f1security.co.kr">F1Security Inc.</a>
              <span>234, Beotkkot-ro, Geumcheon-gu, Seoul, Republic of Korea</span>
              <span> Copyright {{ get_year() }} {{custom && custom.slogan ? custom.slogan : 'F1-UWSS'}} All right reserved. {{ custom.address ? custom.address : '' }} </span>
            </div>
            <div v-else style="margin: 0 auto !important;">
              <!-- 향후 커스텀 정보가 추가될 수 있음 -->
              <span> Copyright {{ get_year() }} {{custom && custom.slogan ? custom.slogan : 'F1-UWSS'}} All right reserved. {{ custom.address ? custom.address : '' }} </span>
            </div>
          </div>
        </footer>
        <!---------------------------------------------------------- footer-->
      </div>
    </div>
  </div>
  </div>
</template>


<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
